import { QueryClientProvider, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

import { createQueryClient } from "@/helpers/query-client";
import { QUERY_KEYS } from "@/query-keys";

/** The caller keys this scope by token. Only public bootstrap data survives a credential change. */
export function QuickReplyQueryScope({ children }: { children: React.ReactNode }): React.ReactNode {
  const parent = useQueryClient();
  const [client] = useState(() => {
    const scoped = createQueryClient();
    const cache = parent.getQueryCache();
    const publicQueries = [
      ...cache.findAll({ queryKey: QUERY_KEYS.LANGUAGES() }),
      ...cache.findAll({ queryKey: ["TRANSLATIONS"] }),
      ...cache.findAll({ queryKey: QUERY_KEYS.CONFIGURATIONS_APP_BRANDING_LIST(), exact: true }),
    ];
    for (const query of publicQueries) {
      if (query.state.data !== undefined) {
        scoped.setQueryData(query.queryKey, query.state.data, { updatedAt: query.state.dataUpdatedAt });
      }
    }

    return scoped;
  });

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
